import jQuery from 'jquery';
import deviceDetect from './deviceDetect';

export const LINK_OVERNIGHT = 'js-RC-cardTabsZone__link_overnight';
export const LINK_NEWSPAPER = 'js-RC-pdfPopover__toggleArea';

export default class CardTabs {
    constructor() {
        this.containerElem = jQuery('.RC-cardTabsZone');
        this.blockElem = jQuery('.RC-cardTabsZone__link');
        this.init();
    }

    init() {
        if (deviceDetect.phone()) {
            this.blockElem.each((index, element) => {
                if (
                    jQuery(element).hasClass(LINK_NEWSPAPER) &&
                    !jQuery(element).hasClass(LINK_OVERNIGHT)
                ) {
                    jQuery(element).hide();
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/cardTabs.js